/**
 * Artwork-scoped comments: generic `comments` rows with target_type = artwork.
 * Endpoints: /api/comments (POST), /api/comments/artwork/:id (GET), /api/comments/:id (PUT/DELETE), /api/comments/:id/like
 */

const API_ROOT = process.env.REACT_APP_API_BASE || "/api";

async function readJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(
      typeof data.error === "string" ? data.error : res.statusText || "Request failed"
    );
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function fetchArtworkComments(artworkId) {
  const res = await fetch(
    `${API_ROOT}/comments/artwork/${encodeURIComponent(String(artworkId))}`,
    { credentials: "include" }
  );
  return readJson(res);
}

export async function postArtworkComment({ artworkId, text, parentCommentId = null }) {
  const comment_text = String(text ?? "").trim();
  if (!comment_text) {
    const err = new Error("Comment text is required");
    err.status = 400;
    throw err;
  }

  const body = {
    target_type: "artwork",
    target_id: Number(artworkId),
    comment_text,
  };
  if (parentCommentId != null && parentCommentId !== "") {
    body.parent_comment_id = Number(parentCommentId);
  }
  const res = await fetch(`${API_ROOT}/comments`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  return readJson(res);
}

export async function updateArtworkComment(commentId, commentText) {
  const res = await fetch(`${API_ROOT}/comments/${encodeURIComponent(String(commentId))}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ comment_text: String(commentText ?? "") }),
  });
  return readJson(res);
}

export async function deleteArtworkComment(commentId) {
  const res = await fetch(`${API_ROOT}/comments/${encodeURIComponent(String(commentId))}`, {
    method: "DELETE",
    credentials: "include",
  });
  return readJson(res);
}
